var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-base',[_c('div',{ref:"page",staticClass:"mod-flower"},[_c('canvas',{ref:"canvas",staticClass:"paint"}),_c('div',{staticClass:"title"},[_vm._v(" 恭喜你 ")]),_c('div',{staticClass:"content"},[_vm._v(" 完成寻宝任务 ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }